export enum BadgeColorTypeEnum {
  basic = 1,
  glow = 2,
  light = 3,
}
